import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
    logoGrid: {
        "&.MuiGrid-root": {
          width: "fit-content",
          position: "relative",
          "& .MuiBox-root": {
            position: "absolute",
            display: "none",
            top: 0,
            left: 0,
            "& .MuiSvgIcon-root": {
              color: theme.palette.common.white,
              fontSize: 20,
            },
          },
          "&:hover": {
            "& .MuiBox-root": {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#00000080",
              // backgroundColor:"red",
              overFlow: "hidden",
            },
          },
        },
      },
    companyLogo: {
    "&.MuiAvatar-root": {
        width: "35px",
        height: "35px",
        padding: 1,
        objectFit: "cover",
        // backgroundColor:"red"
    },
    },
    previewImage: {
        "&.MuiGrid-root": {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiAvatar-root": {
            width: "500px",
            height: "500px",
            "& .MuiAvatar-img": {
              objectFit: "contain",
            },
          },
        },
      },
}))
export default useStyle